"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchLanguages = fetchLanguages;
exports.fetchLanguagesV2 = fetchLanguagesV2;
exports.setCurrentLanguageCode = setCurrentLanguageCode;
exports.languagesProviderSaga = languagesProviderSaga;
const effects_1 = require("redux-saga/effects");
const i18next_1 = __importDefault(require("i18next"));
const env_1 = require("../../utils/env");
const errors_1 = require("../../utils/errors");
const api_1 = require("../../api/languages/api");
const slice_1 = require("./slice");
function* fetchLanguages(action) {
    try {
        const { data } = yield (0, effects_1.call)(api_1.getLanguages);
        yield (0, effects_1.put)(slice_1.languagesProviderActions.fetchLanguagesSuccess({
            languages: data,
            fromServer: !!action.payload.fromServer,
        }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error fetching  languages data', error);
        yield (0, effects_1.put)(slice_1.languagesProviderActions.fetchLanguagesError(error));
    }
}
/* For SPA with retry policy */
function* fetchLanguagesV2(action) {
    try {
        const retryPolicy = action.payload;
        const data = yield (0, effects_1.call)(api_1.getLanguagesWithRetry, retryPolicy);
        yield (0, effects_1.put)(slice_1.languagesProviderActions.fetchLanguagesSuccess({
            languages: data,
            fromServer: false,
        }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching  languages data', error);
        yield (0, effects_1.put)(slice_1.languagesProviderActions.fetchLanguagesError(error));
    }
}
function* setCurrentLanguageCode(action) {
    try {
        i18next_1.default.changeLanguage(action.payload.langCode, () => {
            if (env_1.isBrowser) {
                window.location.reload();
            }
        });
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while set languages state', error);
        yield (0, effects_1.put)(slice_1.languagesProviderActions.fetchLanguagesError(error));
    }
}
function* languagesProviderSaga() {
    yield (0, effects_1.takeLatest)(slice_1.languagesProviderActions.fetchLanguages.type, fetchLanguages);
    yield (0, effects_1.takeLatest)(slice_1.languagesProviderActions.fetchLanguagesV2.type, fetchLanguagesV2);
    yield (0, effects_1.takeLatest)(slice_1.languagesProviderActions.setCurrentLanguageCode.type, setCurrentLanguageCode);
}
//# sourceMappingURL=saga.js.map